export type VideoState = {
  isPlaying: boolean;
  isEnded: boolean;
  currentTime: number;
  duration: number | undefined;
  lastTime: number | null;
};

export enum VideoPlayerSurface {
  Feed = "feed",
  ComedianSpecial = "comedian-special",
  ComedianCheckout = "comedian-checkout",
  Livestream = "livestream",
  Venue = "venue",
}
